import cl from './FormPreloader.module.scss'

export const FormPreloader = () => {
	return <div className={cl.ldsDualRing}></div>
}
